//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Base from './rb-base.vue'
export default {
  name: 'rb-custom-select',
  extends: Base,
  props: {
    id: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    maxDropdownHeight: {
      type: Number,
      default: 210,
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dropdownIsVisible: false,
      inputId: this.id + 'Input',
    }
  },
  computed: {
    adjustedStyle() {
      return {
        'max-height': `${this.maxDropdownHeight}px`,
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    closeDropdown(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.dropdownIsVisible = false
      }
    },
    onElementClick(value) {
      this.dropdownIsVisible = false
      this.$refs.inputField.value = value
      this.$emit('selectedValue', value, this.id)
    },
    onInputClick() {
      this.dropdownIsVisible = true
    },
  },
}
